"use client";

import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Import the background image
import BackgroundImage from "./470064558_122196196148058011_4746601677953993540_n.jpg";
import { AppContext } from "../context/AppContext";

const LoginComponent = () => {
  const navigate = useNavigate(); // Initialize navigation
  const { loginUserEmail, setLoginUserEmail } = useContext(AppContext);

  // Define states for the form fields
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post("/auth/login", {
        email,
        password,
      });

      if (response.status === 200) {
        console.log(response.data.message);

        // Save the JWT token in localStorage (or sessionStorage)
        localStorage.setItem("token", response.data.token);

        setLoginUserEmail(response.data.email);
        navigate("/studentform");
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      localStorage.clear(); // Clear local storage
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center relative bg-gray-900"
      style={{
        backgroundImage: `url(${BackgroundImage})`, // Set the background image
        backgroundSize: "cover", // Make it cover the entire screen
        backgroundPosition: "center", // Center the image
        backgroundRepeat: "no-repeat", // Prevent repeating
      }}
    >
      {/* Overlay Layer */}
      <div className="absolute inset-0 bg-black opacity-75"></div>{" "}
      {/* Semi-transparent overlay */}
      <div className="relative w-full max-w-md bg-gray-800 bg-opacity-90 p-8 rounded-lg shadow-lg">
        {/* Logo */}
        <div className="text-center mb-6">
          <div className="text-blue-500 text-2xl font-bold mb-2">
            NASTP Institute of Information Technology (NIIT)
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-white text-center mb-8">
          Sign in to your account
        </h2>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          {/* Email Input */}
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-300 mb-1"
            >
              Your email
            </label>
            <input
              type="email"
              id="email"
              placeholder="Email"
              className="w-full px-3 py-2 text-sm text-gray-300 bg-gray-700 rounded-lg focus:outline-none focus:ring focus:ring-blue-500"
              value={email} // Bind to state
              onChange={(e) => setEmail(e.target.value)} // Update state
            />
          </div>

          {/* Password Input */}
          <div className="mb-4">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-300 mb-1"
            >
              Password
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="••••••••"
                className="w-full px-3 py-2 text-sm text-gray-300 bg-gray-700 rounded-lg focus:outline-none focus:ring focus:ring-blue-500"
                value={password} // Bind to state
                onChange={(e) => setPassword(e.target.value)} // Update state
              />
              <button
                type="button"
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-white focus:outline-none transition-colors"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
                      clipRule="evenodd"
                    />
                    <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                    <path
                      fillRule="evenodd"
                      d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Remember Me & Forgot Password */}
          <div className="flex justify-end mb-6">
            <span
              onClick={() => navigate("/forgot-password")}
              className="text-sm text-blue-500 hover:underline cursor-pointer"
            >
              Forgot password?
            </span>
          </div>

          {/* Sign In Button */}
          <div className="mb-4">
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 px-4 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-500 flex items-center justify-center"
            >
              {loading && (
                <svg
                  className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              )}
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </div>
        </form>

        {/* Sign Up Link */}
        <p className="text-sm text-center text-gray-300">
          Don't have an account yet?{" "}
          <span
            onClick={() => navigate("/signup")}
            className="text-blue-500 hover:underline cursor-pointer"
          >
            Sign up
          </span>
        </p>

        {/* Go to Home Page Button */}
        <div className="mt-8 text-center border-t border-gray-700 pt-6">
          <button
            onClick={() => navigate("/")}
            className="group relative w-full flex justify-center py-3 px-4 rounded-lg overflow-hidden bg-gradient-to-r from-indigo-600 to-blue-500 text-white transition-all duration-300 hover:from-indigo-700 hover:to-blue-600 shadow-lg hover:shadow-indigo-500/30"
          >
            <span className="absolute right-0 -mt-12 -mr-12 h-32 w-32 rounded-full blur-xl bg-blue-500 opacity-30 group-hover:opacity-40 transition-all duration-500"></span>
            <span className="absolute left-0 -mt-12 -ml-12 h-32 w-32 rounded-full blur-xl bg-indigo-500 opacity-30 group-hover:opacity-40 transition-all duration-500"></span>
            <span className="relative flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2 group-hover:animate-bounce"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
              </svg>
              Return to Home Page
            </span>
          </button>
          <p className="mt-3 text-xs text-gray-400">
            Visit our main website for more information
          </p>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
      />
    </div>
  );
};

export default LoginComponent;
